/**
 * Webinar countdown — public urgency timer.
 *
 * Fetches the fresh next occurrence from /api/yeeter-next.php (so the cached page can't freeze the
 * target), ticks down to it, shows a "live" state during the webinar, and when that occurrence ends
 * re-fetches the following one. Token-gated states (video / register-again) live in the separate
 * webinar-embed block. The digit renderer is exported for that block to reuse.
 */

function pad(n) {
  return String(n).padStart(2, '0');
}

/** Fill [data-unit="days|hours|minutes|seconds"] inside `el` from a remaining-seconds value. */
export function renderDigits(el, remaining) {
  const d = Math.floor(remaining / 86400);
  const h = Math.floor((remaining % 86400) / 3600);
  const m = Math.floor((remaining % 3600) / 60);
  const s = Math.floor(remaining % 60);
  const set = (unit, val) => {
    const node = el.querySelector(`[data-unit="${unit}"]`);
    if (node) node.textContent = unit === 'days' ? String(d) : pad(val);
  };
  set('days', d);
  set('hours', h);
  set('minutes', m);
  set('seconds', s);
}

function show(el, which) {
  const timer = el.querySelector('[data-wc-timer]');
  const live = el.querySelector('[data-wc-live]');
  if (timer) timer.classList.toggle('hidden', which !== 'timer');
  if (live) live.classList.toggle('hidden', which !== 'live');
}

/** Drive the public countdown. opts: { now, onEnded }. */
function engine(el, startTs, lengthS, opts = {}) {
  const now = opts.now || (() => Date.now() / 1000);
  const endTs = startTs + lengthS;

  const tick = () => {
    const t = now();
    if (t < startTs) {
      show(el, 'timer');
      renderDigits(el, startTs - t);
    } else if (t < endTs) {
      show(el, 'live');
    } else {
      clearInterval(el.__wcTimer);
      el.__wcTimer = null;
      if (typeof opts.onEnded === 'function') opts.onEnded();
    }
  };

  if (el.__wcTimer) clearInterval(el.__wcTimer);
  tick();
  el.__wcTimer = setInterval(tick, 1000);
}

async function loadPublic(el) {
  const ms = el.dataset.ms || '';
  const endpoint = el.dataset.endpoint || '/api/yeeter-next.php';
  let start = parseInt(el.dataset.next || '0', 10);
  let length = parseInt(el.dataset.length || '3600', 10);
  let now = () => Date.now() / 1000;

  try {
    const res = await fetch(`${endpoint}?ms=${encodeURIComponent(ms)}`, {
      headers: { Accept: 'application/json' },
    });
    if (res.ok) {
      const data = await res.json();
      if (data.ok && data.next_start) {
        start = data.next_start;
        length = data.length || length;
        if (data.server_now) {
          const skew = data.server_now - Date.now() / 1000;
          now = () => Date.now() / 1000 + skew;
        }
      }
    }
  } catch (e) {
    /* fall back to the SSR hint in data-next */
  }

  if (!start) return; // nothing scheduled
  engine(el, start, length, { now, onEnded: () => loadPublic(el) });
}

export function webinarCountdown() {
  document.querySelectorAll('[data-webinar-countdown]').forEach((el) => loadPublic(el));
}
